import { AnalyticsInterceptor } from './analytics-interceptor'
import { ErrorkickoutInterceptor } from './error-kickout-interceptor'
import { LoaderInterceptor } from './loader-interceptor'
import { SessionInterceptor } from './session-interceptor'
import { SessionTimeOutInterceptor } from './session-timeout-interceptor'

export const AllInterceptors = {
    ErrorkickoutInterceptor: ErrorkickoutInterceptor,
    AnalyticsInterceptor : AnalyticsInterceptor,
    LoaderInterceptor: LoaderInterceptor,
    SessionInterceptor: SessionInterceptor,
    SessionTimeOutInterceptor: SessionTimeOutInterceptor
}
 